import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAuthToken } from '../TokenContext';
import { useIntl, FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

const EpicsCountGraph = () => {
  const [epicsData, setEpicsData] = useState({ open_epics: 0, completed_epics: 0 });
  const { user } = useSelector((state) => state.auth);
  const intl = useIntl();
  const token = useAuthToken();

  useEffect(() => {
    fetchData();
  }, [token]);
  
  const fetchData = async () => {
    if (!token) {
      return; // Exit early if there is no token
    }
    if (user.data[0].type === "stakeholder") {
      await fetchStakeholderEpics();
    } else if (user.data[0].type === "Candidate") {
      await fetchTalentEpics();
    } else {
      await fetchManagerEpics();
    }
  };
  
  const fetchStakeholderEpics = async () => {
    try {
      const payload = {
        org_code: user.data[0].client_code,
        pod_id: [],
        sprint_name: ''
      };

      const response = await fetch(process.env.REACT_APP_STAKEHOLDER_EPICSCOUNTSTAKEHOLDER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });
  
      const data = await response.json();
      
      if (data?.body) {
        setEpicsData(data.body);
      }
    } catch (error) {
      console.log('Error fetching stakeholder epics:', error);
    }
  };
  
  const fetchTalentEpics = async () => {
    try {
      const payload = {
        c_id: user.data[0].c_id,
        pod_id: [],
        sprint_name: ''
      };

      const response = await fetch(process.env.REACT_APP_TALENT_EPICSCOUNTTALENT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });
  
      const data = await response.json();
      
      if (data?.body) {
        setEpicsData(data.body);
      }
    } catch (error) {
      console.log('Error fetching talent epics:', error);
    }
  };
  
  const fetchManagerEpics = async () => {
    try {      
      const payload = {
        manager_id: user.data[0].emp_id,
        pod_id: [],
        sprint_name: ''
      };

      const response = await fetch(process.env.REACT_APP_CLIENT_EPCCOUNTMANAGER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });
  
      const data = await response.json();
      
      if (data?.body) {
        setEpicsData(data.body);
      }
    } catch (error) {
      console.log('Error fetching manager epics:', error);
    }
  };
  
  return (
    <div>
      <Typography variant="body2">
        {intl.formatMessage({ id: 'toDo' }, { defaultMessage: 'TO DO' })}: {epicsData.open_epics || 0}
      </Typography>
      <Typography variant="body2">
        {intl.formatMessage({ id: 'Done' }, { defaultMessage: 'DONE' })}: {epicsData.completed_epics || 0}
      </Typography>
    </div>
  );
};

export default EpicsCountGraph;